import update from "immutability-helper";

import {
  SET_USER,
  UPDATE_USER,
  UPDATE_LANGUAGE
} from "../constants/actionTypes";

const user = (state = "", action) => {
  switch (action.type) {
    case SET_USER:
      return action.payload;
    case UPDATE_USER:
      return {
        ...state,
        ...action.payload
      };
    case UPDATE_LANGUAGE:
      return update(state, {
        language: { $set: action.payload.language },
        languageId: { $set: action.payload.languageId }
      });
    default:
      return state;
  }
};

export default user;
